import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PublicModal from 'components/PublicModal'
import { MessengerIcon, PhoneCallbackIcon, PhoneIcon } from 'components/icons'
import LogoLink from 'components/logoLink'
import { useSelector } from 'react-redux'
import GetHelpModal from 'components/modals/getHelp/GetHelpModal'
import CenteredCustomerLoginModal from 'components/modals/getHelp/CenteredCustomerLoginModal'
import { config } from 'data/config'

const CustomerGetInTouchModal = ({ modalOpen, onClose, region }) => {
  const { user } = useSelector(state => ({
    user: state.auth.user,
  }))

  const [giveUsACallHovered, setGiveUsACallHovered] = useState(false)

  const [getHelpModalOpen, setGetHelpModalOpen] = useState(false)
  const [loginModalOpen, setLoginModalOpen] = useState(false)
  const [modalType, setModalType] = useState(null)

  const setModal = (type) => {
    setModalType(type)
    if (type === 'general' && !user) {
      setLoginModalOpen(true)
    } else {
      setGetHelpModalOpen(true)
    }
  }

  useEffect(() => {
    if (user && modalType === 'general') {
      setTimeout(() => {
        setGetHelpModalOpen(true)
      }, 300)
    }
  }, [user])

  return (
    <PublicModal
      isOpen={modalOpen}
      onClose={() => onClose()}
      className={`max-w-[452px] ${getHelpModalOpen || loginModalOpen ? 'hidden' : ''}`}
      innerPadding="!px-20 !pb-70 !pt-40 lg:!px-40 lg:!pt-50"
    >
      <div className="flex flex-col items-center gap-30">
        <LogoLink className="w-[130px] focus:outline-none" />
        <div className="flex flex-col gap-10 text-center">
          <p className="font-bold text-grey-900 text-16">Get in touch with us</p>
          <h3 className="text-grey-500 text-14">
            Any questions? We’re here to help.<br />
            Reach out to us via your preferred contact method below.<br />
            We look forward to hearing from you!
          </h3>
        </div>
        <div className="flex flex-col gap-15">
          <button
            className="flex py-20 text-left border border-black rounded-5 px-25 gap-25 text-grey-900 hover:text-grey-700 border-opacity-40 hover:border-opacity-20"
            onClick={() => setModal('callback')}
          >
            <div className="mt-5 text-18">
              <PhoneCallbackIcon />
            </div>
            <div>
              <h4 className="text-18">Request a callback</h4>
              <p className="mt-10 text-grey-1000 text-opacity-40 text-16">Our line is busy or it’s outside of office hours? Request a callback here.</p>
            </div>
          </button>
          <div
            className="flex items-center py-20 border border-black cursor-pointer rounded-5 px-25 gap-25 hover:bg-primary text-grey-900 hover:text-white border-opacity-40 hover:border-primary hover:border-opacity-100"
            onMouseEnter={() => setGiveUsACallHovered(true)}
            onMouseLeave={() => setGiveUsACallHovered(false)}
          >
            <PhoneIcon />
            <a
              id="call-ama-selections"
              href={`tel:${config.amaSelectionsPhoneNumber}`}
              className="text-18"
            >
              {giveUsACallHovered ? config.amaSelectionsDisplayPhoneNumber : 'Give us a call'}
            </a>
          </div>
          <button
            className="flex items-center py-20 border border-black rounded-5 px-25 gap-25 text-grey-900 hover:text-grey-700 border-opacity-40 hover:border-opacity-20"
            onClick={() => setModal('general')}
          >
            <MessengerIcon />
            <h4 className="text-18">Send us a message</h4>
          </button>
        </div>
      </div>

      <GetHelpModal modalOpen={getHelpModalOpen} onClose={() => setGetHelpModalOpen(false)} initialType={modalType} region={region} />
      <CenteredCustomerLoginModal modalOpen={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
    </PublicModal>
  )
}

CustomerGetInTouchModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  region: PropTypes.object,
}

export default CustomerGetInTouchModal
